import Vue from 'vue';
import axios from 'axios';

axios.defaults.headers['Content-Type'] = 'application/json';

// http请求拦截器
axios.interceptors.request.use(
    config => {
        config.withCredentials = true; // 允许跨域cookie
        return config;
    },
    err => Promise.reject(err)
);

// http响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data instanceof Object) {
            if (response.data && response.data.redirect) {
                window.location.replace(response.data.redirect);
            }
            if (response.data && 'status' in response.data && !response.data.status) {
                Vue.prototype.$message.error(response.data.msg || '网络请求异常');
                return Promise.reject(response);
            }
        }
        return response;
    },
    err => Promise.reject(err)
);



Vue.prototype.$http = axios;
Vue.prototype.$baseURL = axios.defaults.baseURL || '';